export default __webpack_public_path__ + "static/subset-UniNeueRegular-Italic-15d96a124ce1778e1d6bb38a7a066c67.woff";